// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox{display:flex;margin-block:15px;margin-inline:0;cursor:pointer}.checkbox__input{margin-inline-end:10px}.aem-checkbox--dark .checkbox__label{color:#3567ff}", ""]);
// Exports
module.exports = exports;
